/**
 * Required for specific business logic rules, includes a list of Certificate Group Ids that are considered constant in the application.
 * TODO: Guarantee that the Ids present here are saved as such in the Database through proper seeding.
 */
export enum AvailableLanguageCertificateGroups {
  JLPT = 1,
  TOEFL = 2
}
